export const VARIANTS = {
  PROGRESS: "progress",
  PLAN: "plan",
  HANDLER: "handler",
  HANDLER_DRAFT: "handlerDraft",
  HANDLER_PRODUCTION: "handlerProduction",
  PRICING_MODE_BUDGET: "pricingModeBudget" ,
  PRICING_MODE_ESTIMATED_PRICE: "pricingModeEstimatedPrice"
} as const;
